const CODE_MESSAGES = {
  'auth/invalid-credential': 'Correo o contraseña incorrectos.',
  'auth/user-not-found': 'Correo o contraseña incorrectos.',
  'auth/wrong-password': 'Correo o contraseña incorrectos.',
  'auth/invalid-email': 'El correo no es válido.',
  'auth/user-disabled': 'Esta cuenta está deshabilitada.',
  'auth/too-many-requests': 'Demasiados intentos. Intenta más tarde.',
  'auth/network-request-failed': 'Error de red. Revisa tu conexión.',
  'permission-denied': 'No tienes permisos para realizar esta acción.',
  'unavailable': 'No se pudo cargar la información. Intenta de nuevo.',
  'failed-precondition': 'La operación no se puede completar ahora.',
};

/** Traduce errores de Firebase a mensajes amigables. El detalle técnico va a console. */
export function friendlyError(error) {
  if (!error) return 'Ocurrió un error inesperado.';
  const code = error.code || '';
  console.error('[admin]', code || error.message, error);
  return (
    CODE_MESSAGES[code] ||
    error.message ||
    'No se pudo completar la operación.'
  );
}

export function isPermissionError(error) {
  const code = error?.code || '';
  return code.includes('permission-denied') || code.includes('unauthenticated');
}
